/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamPracticeAvailabilityResponse } from './oralExamPracticeAvailabilityResponse';

export type GenericApiResponseOralExamPracticeAvailabilityResponseData = OralExamPracticeAvailabilityResponse | null;
